import { useState } from "react";
import MDTypography from "components/MDTypography";
import { IconButton, Tooltip } from "@mui/material";
import DownloadingIcon from "@mui/icons-material/Downloading";
import CTLNotification from "application/components/CTLNotification";
import variables from "globals/variables";
import { application } from "globals/endpoints";
import DownloadIcon from "@mui/icons-material/Download";
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
function DownloadSingleForBackup({ row }) {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const filename = row?.original?.recordFilename;
  const uuid = row?.original?.uuid;

  // Secure UUID-based download. We mint the short-lived vp_st cookie via the
  // authenticated client, then trigger a native browser download so the browser
  // renders its own progress/percent and saves using the server's
  // Content-Disposition filename. No filesystem path is exposed in the URL.
  async function onDownloadFile() {
    if (!filename || !uuid) {
      setNotify({
        isOpen: true,
        message: "Unable To Download File: File Not Exist",
        type: "error",
        pagename: "voice picker",
      });
      return;
    }
    try {
      await application.get(`/voiceLogger/media/${uuid}/streamToken`);
      const downloadUrl = `${variables.api.services}voiceLogger/media/${uuid}/download`;
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setNotify({
        isOpen: true,
        message: "Recording download started",
        type: "success",
      });
    } catch (error) {
      console.error("Error:", error);
      setNotify({
        isOpen: true,
        message: "Unable To Download File",
        type: "error",
        pagename: "voice picker",
        status: error.response ? error.response.status : null,
      });
    }
  }

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      <tooltip title="DownloadFile">
        <IconButton color="error" onClick={() => onDownloadFile()}>
         {filename ? <DownloadIcon/> : <DoNotDisturbAltOutlinedIcon/>} 
        </IconButton>
      </tooltip>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDTypography>
  );
}

export default DownloadSingleForBackup;
